import type { InternalRequest } from '../client.js';

/**
 * /api/work/:id/form-requirements — declarative gating: which forms must
 * be submitted for the Work (or a specific stop) before status can
 * transition to completed.
 */
export function formRequirementsEndpoints(req: InternalRequest) {
  return {
    list: (workId: string) =>
      req.request<unknown[]>(`/work/${workId}/form-requirements`),
    replace: (
      workId: string,
      body: {
        workLevelFormIds?: string[];
        stopRequirements?: { stopId: string; formIds: string[] }[];
      },
    ) =>
      req.request<unknown>(`/work/${workId}/form-requirements`, {
        method: 'PATCH',
        body: JSON.stringify(body),
      }),
  };
}
